<template>
	<div class="vld-parent" v-if="!businessesDataLoaded">
		<loading :active="true" />
	</div>
	<GuestCheckout v-else-if="isResidentialGuest" ref="checkout" />
	<ResidentialCheckout v-else-if="isResidential" ref="checkout" />
	<AirportCheckout v-else-if="isAirport" ref="checkout" />
	<DefaultCheckout v-else ref="checkout" />
</template>

<style scoped>
* >>> .navbar-white {
	z-index: unset;
}
</style>

<script>
import DefaultCheckout from "@/components/checkout/DefaultCheckout.vue"
import ResidentialCheckout from "@/components/checkout/ResidentialCheckout.vue"
import GuestCheckout from "@/components/checkout/GuestCheckout.vue"
import AirportCheckout from "@/components/checkout/AirportCheckout.vue"
import Loading from "vue-loading-overlay"
import { BusinessType } from "@reef-os/utils/enums/businessType"

export default {
	name: "Checkout",
	components: {
		DefaultCheckout,
		ResidentialCheckout,
		GuestCheckout,
		AirportCheckout,
		Loading
	},
	data: function () {
		return {
			mounted: false
		}
	},
	computed: {
		isResidential() {
			return this.$store.getters.isResidential
		},
		isResidentialGuest() {
			return (
				this.isResidential &&
				this.$store.state.temporaryFlag.isGuestCheckoutActive
			)
		},
		isAirport() {
			return (
				this.$store.state.business &&
				this.$store.state.business.type == BusinessType.AIRPORT
			)
		},
		businessesDataLoaded() {
			return (
				this.$route.params.slug == this.$store.state.business.slug &&
				this.mounted &&
				!this.$store.state.loading
			)
		}
	},
	beforeRouteUpdate: function (to, from, next) {
		this.$refs.checkout.beforeRouteUpdate(to, from, next)
		next()
	},
	mounted: function () {
		this.mounted = true
	}
}
</script>